import React from "react";

import NewTabLink from "./newTabLink";

import { PUBLIC_SITE_URL } from "../../env";

import { ReactComponent as LogoGrassrootz } from "../../semantic/assets/images/logo-grassrootz.svg";

const PoweredBy = () => {
  const publicSiteUrl = PUBLIC_SITE_URL;
  return (
    <div className="powered-by-small">
      <div className="powered-by-small-inner">
        <NewTabLink href={publicSiteUrl}>
          <span>Powered by</span>
          <span>
            <LogoGrassrootz />
          </span>
        </NewTabLink>
      </div>
    </div>
  );
};

export default PoweredBy;
